var _defs, _animateTransform, _animateTransform2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinnerShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "SVG-Nano-001",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shad",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offOut",
    in: "SourceGraphic",
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "black",
    floodOpacity: 0.45,
    result: "color"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blurOut",
    in: "offOut",
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "blurOut",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("path", {
    filter: "url(#shad)",
    style: {
      fill: "#e7e7e7"
    },
    d: "m37.897,73.288c-.386,0-.776-.098-1.134-.305-8.178-4.719-13.268-13.509-13.283-22.941-.002-1.255,1.014-2.275,2.27-2.277h.004c1.254,0,2.271,1.015,2.273,2.27.013,7.815,4.231,15.099,11.009,19.01,1.088.627,1.46,2.018.833,3.105-.421.729-1.185,1.138-1.971,1.138Zm24.243-.021c-.784,0-1.547-.406-1.969-1.134-.629-1.086-.259-2.477.827-3.106,6.77-3.923,10.976-11.214,10.976-19.028v-.081c0-1.255,1.018-2.273,2.273-2.273s2.273,1.018,2.273,2.273v.065c0,9.447-5.074,18.246-13.243,22.978-.359.208-.751.307-1.137.307Zm-24.311-41.97c-.783,0-1.545-.405-1.967-1.131-.631-1.085-.263-2.477.822-3.108,4.028-2.342,8.632-3.58,13.316-3.58,4.636,0,9.2,1.215,13.198,3.513,1.088.626,1.464,2.015.838,3.104-.626,1.089-2.015,1.463-3.104.838-3.31-1.902-7.09-2.908-10.933-2.908-3.882,0-7.696,1.025-11.03,2.964-.36.209-.753.309-1.141.309Z"
  }, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "360 50 50",
    to: "0 50 50",
    dur: "1s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("path", {
    filter: "url(#shad)",
    style: {
      fill: "#e7e7e7"
    },
    d: "m27.796,93.067c-.772,0-1.553-.196-2.27-.61C10.417,83.73,1.019,67.482,1,50.053c-.003-2.511,2.031-4.548,4.542-4.551h.005c2.509,0,4.543,2.032,4.546,4.541.015,14.196,7.672,27.431,19.981,34.54,2.174,1.256,2.919,4.036,1.663,6.211-.842,1.458-2.37,2.273-3.941,2.273Zm44.453-.026c-1.569,0-3.096-.813-3.939-2.269-1.258-2.173-.517-4.954,1.656-6.213,12.3-7.123,19.941-20.366,19.941-34.561v-.098c0-2.511,2.035-4.546,4.546-4.546s4.546,2.035,4.546,4.546v.098c0,17.428-9.379,33.686-24.477,42.429-.717.415-1.501.613-2.274.613ZM27.717,16.075c-1.567,0-3.092-.811-3.936-2.264-1.261-2.171-.522-4.954,1.649-6.214,7.433-4.315,15.93-6.597,24.569-6.597h.001c8.582,0,17.029,2.253,24.427,6.514,2.176,1.253,2.923,4.033,1.67,6.209-1.253,2.176-4.033,2.923-6.209,1.67-6.019-3.467-12.896-5.3-19.888-5.3-7.039,0-13.956,1.856-20.005,5.368-.718.417-1.503.615-2.278.615Z"
  }, _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 50 50",
    to: "360 50 50",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerShape);
export default __webpack_public_path__ + "static/media/SpinnerShape.176179098c7db0830b83119bb895ebc5.svg";
export { ForwardRef as ReactComponent };